import { CButton } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarButton = (props) => {
  const { children } = props
  return (
    <CButton size={'sm'} {...props}>
      {children}
    </CButton>
  )
}

export { ConfiaCarButton }
